// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__1rkHi","info":"Alert_info__2Q_No","success":"Alert_success__2FJwX","error":"Alert_error__3geWi","closeIcon":"Alert_closeIcon__fukOT"};